import { React, useState, useEffect } from "react";
import { Button, Form, Input } from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../../Assets/Icons/alertGreen.svg";
import { DisabledStyles } from "../../../pageStyled";
import { cancelProduction, cancelMultiStageProduction } from "../../../../Services/productionPlanningServices";

const { TextArea } = Input;

const CancelJobCardDrawer = ({
  jobId,
  visible,
  onClose,
  setActionResponse,
  showToaster,
  reFetch,
  onCancelSuccess,
  isCancelLoadingToggle,
  jobcardType,
  tabNo,
  jobcardCode
}) => {
  const [form] = Form.useForm();

  const cancelJobCardProduction = (comment) => {
    if (isCancelLoadingToggle) isCancelLoadingToggle(true);
    if(jobcardType == "single_stage"){
      cancelProduction({ id: jobId, comment: comment })
        .then((response) => {
          setActionResponse(response.data);
          showToaster();
          reFetch(true);
        })
        .catch((error) => {
          setActionResponse(error.response.data);
          showToaster();
        }).finally(()=>{if(isCancelLoadingToggle) isCancelLoadingToggle(false)});
    } else{
      cancelMultiStageProduction({ id: jobId, comment: comment })
      .then((response) => {
        setActionResponse(response.data);
        showToaster();
        reFetch(true);
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      }).finally(()=>{if(isCancelLoadingToggle) isCancelLoadingToggle(false)});
    }
  };

  const onFinish = async (e) => {
    cancelJobCardProduction(e.reason);
    onClose();
    onCancelSuccess();
  };

  useEffect(() => {
    form.resetFields();
  }, [jobId]);

  return (
    <RightDrawerSidebar
      title="Cancel Production"
      subtitle=""
      visible={visible}
      onClose={onClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <HaberForm>
            <Form
              name="basic"
              form={form}
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              onFinish={onFinish}
            >
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Job Card Number</h5>
                  <p>An auto-generated code to identify job card</p>
                </div>

                <DisabledStyles>
                  <Form.Item
                    name="jobId"
                    rules={[{ required: true }]}
                    initialValue={jobcardCode}
                  >
                    <Input disabled className="requestChangeValue" />
                  </Form.Item>
                </DisabledStyles>
              </div>

              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Reason</h5>
                  <p>Please specify a reason for rejecting this job card</p>
                </div>
                <Form.Item
                  name="reason"
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                  className=""
                >
                  <TextArea
                    maxLength={100}
                    style={{ height: 90 }}
                    placeholder={"Text"}
                  />
                </Form.Item>
              </div>
              <div className="buttonFlex fixedBtm">
                <Form.Item>
                  <Button htmlType="submit" className="themeBtn">
                    <Iconmoon icon="wrong" size={16} color="#ffffff" />
                    Cancel Job Card
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
        </div>

        <AlertContainer
          color="yellow btmFix"
          icon={alertBlue}
          msg="Once the production of this job card is cancelled, the orders will be reverted to pending quantity and need to be matched again for production."
        />
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default CancelJobCardDrawer;
